import { openapiClient, unwrapResult } from '@/api/openapi-client';
import type { Reservation } from '@restaurant/api-client';
import { useQuery } from '@tanstack/react-query';

export function useReservationDetail(reservationId: string) {
  return useQuery({
    queryKey: ['reservations', reservationId],
    queryFn: async () =>
      unwrapResult<Reservation>(
        await openapiClient.GET('/api/reservations/{reservationId}', {
          params: { path: { reservationId } },
        }),
      ),
    enabled: !!reservationId,
  });
}
